export default {
  props: {
    payload: {
      type: Object,
      required: true,
    },
  },
  emits: ['close', 'loading'],
};
